module.exports = __webpack_public_path__ + "img/02-title-02-m.2b058754.png";